import React from 'react';
import { motion } from 'framer-motion';
import { GenogramDiagram, ConnectedSilhouettes, ConstellationNodeMap, SystemicTriad, ALL_CONSTELLATION_SYMBOLS } from './ConstellationSymbols';
export function SystemicNetwork() {
  // Enhanced paths for better coverage in margins and transitions
  const paths = [
  // Left side organic flow
  {
    d: 'M -20,50 Q 80,400 30,800 T 60,1500 T -10,2200 T 40,2900 T 10,3500',
    opacity: 0.12
  },
  // Right side organic flow
  {
    d: 'M 1020,150 Q 920,500 970,1000 T 940,1800 T 1010,2500 T 960,3100 T 1030,3800',
    opacity: 0.12
  },
  // Transition Hero -> Sales Copy
  {
    d: 'M 50,750 Q 500,700 950,780',
    opacity: 0.1
  },
  // Transition Sales Copy -> WhatYouReceive
  {
    d: 'M 950,1350 Q 500,1400 50,1320',
    opacity: 0.1
  },
  // Transition WhatYouReceive -> Bonuses
  {
    d: 'M 50,1950 Q 500,1900 950,1980',
    opacity: 0.1
  },
  // Transition Bonuses -> Testimonials
  {
    d: 'M 950,2650 Q 500,2700 50,2620',
    opacity: 0.1
  }];
  const watermarks = [
  // Large faded symbols in corners and transitions
  {
    Icon: GenogramDiagram,
    x: -100,
    y: 200,
    size: 400,
    opacity: 0.04,
    rotate: 15
  }, {
    Icon: ConstellationNodeMap,
    x: 700,
    y: 600,
    size: 500,
    opacity: 0.03,
    rotate: -10
  }, {
    Icon: ConnectedSilhouettes,
    x: -150,
    y: 1500,
    size: 450,
    opacity: 0.04,
    rotate: 5
  }, {
    Icon: SystemicTriad,
    x: 750,
    y: 2200,
    size: 400,
    opacity: 0.03,
    rotate: -15
  }, {
    Icon: ALL_CONSTELLATION_SYMBOLS[4],
    x: -100,
    y: 3000,
    size: 500,
    opacity: 0.04,
    rotate: 20
  }, {
    Icon: ALL_CONSTELLATION_SYMBOLS[5],
    x: 800,
    y: 3600,
    size: 400,
    opacity: 0.03,
    rotate: -5
  }];
  const nodes = [{
    x: 30,
    y: 800,
    size: 3,
    opacity: 0.15
  }, {
    x: 970,
    y: 1000,
    size: 4,
    opacity: 0.12
  }, {
    x: 50,
    y: 1320,
    size: 3,
    opacity: 0.15
  }, {
    x: 910,
    y: 2180,
    size: 3,
    opacity: 0.12
  }, {
    x: 60,
    y: 1500,
    size: 4,
    opacity: 0.15
  }, {
    x: 960,
    y: 3100,
    size: 3,
    opacity: 0.12
  }];
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden select-none" data-id="element-205">
      <svg viewBox="0 0 1000 4000" className="w-full h-full" preserveAspectRatio="xMidYMin slice" fill="none" data-id="element-206">
        {/* Large Watermark Symbols */}
        {watermarks.map((item, i) => <motion.g key={`watermark-${i}`} initial={{
        x: item.x,
        y: item.y
      }} animate={{
        x: [item.x, item.x + 20, item.x],
        y: [item.y, item.y - 20, item.y],
        rotate: [item.rotate, item.rotate + 2, item.rotate]
      }} transition={{
        duration: 20 + i * 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="text-blue-400" style={{
        opacity: item.opacity
      }} data-id="element-207">
            <item.Icon size={item.size} data-id="element-208" />
          </motion.g>)}

        {/* Systemic Lines */}
        {paths.map((path, i) => <motion.path key={`path-${i}`} d={path.d} stroke="#3b82f6" // blue-500
      strokeWidth="0.6" strokeOpacity={path.opacity} initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: 1,
        transition: {
          duration: 5,
          delay: i * 0.4,
          ease: 'easeInOut'
        }
      }} data-id="element-209" />)}

        {/* Subtle Nodes */}
        {nodes.map((node, i) => <motion.circle key={`node-${i}`} cx={node.x} cy={node.y} r={node.size} fill="#60a5fa" // blue-400
      fillOpacity={node.opacity} animate={{
        opacity: [node.opacity, node.opacity * 1.5, node.opacity],
        scale: [1, 1.2, 1]
      }} transition={{
        duration: 6 + i,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-210" />)}
      </svg>
    </div>;
}